import React from 'react';

export default ({
    context: { service, config, localization, editable, components },
    onAction,
}) => {
    return (
        <React.Fragment>
            <components.AuthenticateView
                service={service}
                config={config}
                localization={localization}
                components={components}
                editable={editable}
                onAction={onAction}
            />
            <components.ProductMappingView
                service={service}
                localization={localization}
                components={components}
                editable={editable}
                config={config}
            />
            <components.SyncScheduleView
                service={service}
                config={config}
                localization={localization}
                components={components}
                editable={editable}
                onAction={onAction}
            />
        </React.Fragment>
    );
};
